import api from '@pray/shared/utils/api';

import type { WorkflowTemplatesResponse } from './data/response';

type ListTemplatesProps = {
  artistId: string;
  limit?: number;
  offset?: number;
  category?: string;
  search?: string;
};

export async function listTemplates({
  artistId,
  limit = 25,
  offset = 0,
  category,
  search,
}: ListTemplatesProps): Promise<WorkflowTemplatesResponse> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/templates`;
  const params: Record<string, string | number> = {
    limit,
    offset,
  };

  if (category) params.category = category;
  if (search) params.search = search;

  const response = await api.executeGetRequest<WorkflowTemplatesResponse>(url, params);
  return response.data;
}
